import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loadable from '@/components/common/loadable';
import { getCustomerDetail } from '@/store/actions/customer';
import Loading from '@/components/common/loading';

const CustomerInfo = Loadable({ loader: () => import('@/components/customer/detail') });

export default function CustomerInformation({ match: { params } }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(({ customer }) => customer.isLoading);
  useEffect(() => {
    dispatch(getCustomerDetail({ ...params }));
  }, []);

  if (isLoading) return <Loading isLoading />;
  return <CustomerInfo />;
}
